import {requestContext} from '../../../common/requestContext';
import {AskSubCategory} from '../constant';

export function getAskSubCategory() {
  const {isAndroid, isIos, isWebView} = requestContext.requestInfo.display;

  // WebView에서만 자동으로 서브 카테고리를 설정합니다.
  if (!isWebView) {
    return AskSubCategory.Default;
  }

  if (isAndroid) {
    return AskSubCategory.Android;
  }
  if (isIos) {
    return AskSubCategory.Ios;
  }
  return AskSubCategory.Default;
}
